import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { isProduct, ProductId } from "multitenancy/product";

import Multiline from "components/Multiline";

import { Container, TimeContainer } from "./styles";
import { InputComponent } from "../../../../components/Details/InputTime";
import { DropdownGlobal } from "../../../../components/DropdownGlobal";
import { useTenant } from "../../../../multitenancy/config";
import api from "../../../../services/api";
import { useQuery } from "../../../../utils/get";

type IMarkingChildrenModal = {
  marking: any;
  toEditItem: any;
  isEdit: boolean;
  error: boolean;
  hasTriedSubmit: boolean;
  subject: string;
  setSubject: (e: string) => unknown;
  setAttendantId: (id: any) => unknown;
  attendantId: number | undefined;
  isBegining: boolean;
};

export const MarkingChildrenModal: React.FC<IMarkingChildrenModal> = ({
  marking,
  subject,
  setSubject,
  isBegining,
  setAttendantId,
  attendantId,
  isEdit,
  hasTriedSubmit,
}) => {
  const { t } = useTranslation();
  const [attedants, setAttedants] = useState<any[]>([]);
  const [loadingAttendant, setLoadingAttendant] = useState(false);
  const [defaultAttedantName, setDefaultAttedantName] = useState("");
  const query = useQuery();
  const { productId } = useTenant();

  const isRequiredList = {
    attendant: true,
    selectedTime: true,
    durationTime: true,
    description: true,
  };

  const hearingId = query.get("hearingId");
  const queryAttendantId = query.get("attendantId");
  const isInqueritoProduct = productId === ProductId.Inquerito;
  const hearingFileId = query.get("hearingFileId");
  const isInquerito = isProduct(ProductId.Inquerito);

  useEffect(() => {
    if (!isEdit && marking.playerState.offset2 === "00:00" && isBegining) {
      setSubject("");
    }
  }, []);

  useEffect(() => {
    (async () => {
      const shouldFetchByAttendantId = isInqueritoProduct && queryAttendantId;
      const shouldFetchByHearingId = Boolean(hearingId);

      if (!shouldFetchByAttendantId && !shouldFetchByHearingId) {
        return;
      }

      try {
        setLoadingAttendant(true);
        setDefaultAttedantName("");

        if (shouldFetchByAttendantId) {
          const { data } = await api.get(
            `/v1/Attendant/Get?id=${queryAttendantId}`,
          );
          const attendant = data?.data;
          const attendants = Array.isArray(attendant)
            ? attendant
            : attendant
              ? [attendant]
              : [];

          if (attendants.length) {
            setDefaultAttedantName(attendants[0]?.name);
            setAttendantId(attendants[0]?.id);
          }

          setAttedants(attendants);
          return;
        }

        const { data } = await api.get(
          `/v1/Attendant/GetAllByHearingId?hearingId=${hearingId}`,
        );

        let list: any[] = data?.data ?? [];

        if (isInquerito && hearingFileId) {
          try {
            const { data: hf } = await api.get(
              `/v1/HearingFile/Get?id=${hearingFileId}`,
            );
            const lockedAttendantId =
              hf?.data?.attendantId ?? hf?.data?.AttendantId ?? null;
            if (lockedAttendantId) {
              list = list.filter((a: any) => a?.id === lockedAttendantId);
              setAttendantId(lockedAttendantId);
            }
          } catch {
            // fallback: keep full list if HearingFile.Get fails
          }
        }

        setAttedants(list as any);
      } catch (error) {
        console.log("Error no attedant >>>> ", error);
      } finally {
        setLoadingAttendant(false);
      }
    })();
  }, [
    hearingId,
    hearingFileId,
    isInquerito,
    isInqueritoProduct,
    queryAttendantId,
    setAttendantId,
  ]);

  useEffect(() => {
    if (!attendantId) {
      setDefaultAttedantName("");
      return;
    }

    const selectedAttendant = attedants.find(
      (attendant: any) => attendant?.id === attendantId,
    );

    if (selectedAttendant) {
      setDefaultAttedantName(
        selectedAttendant?.name || selectedAttendant?.label || "",
      );
    }
  }, [attedants, attendantId]);

  const handleSelectedAttendant = (attendant: any) => {
    if (
      !attendant ||
      typeof attendant !== "object" ||
      attendant.id === undefined ||
      attendant.id === null
    ) {
      return;
    }

    setAttendantId(attendant.id);
    setDefaultAttedantName(attendant?.name || attendant?.label || "");
  };

  const descriptionHasError = hasTriedSubmit && !subject?.trim();

  return (
    <Container>
      <TimeContainer>
        <InputComponent
          defaultValue={marking.playerState.offset1}
          placeholder={marking.playerState.offset1}
          disabled={true}
          required={isRequiredList.selectedTime}
          onChange={() => {}}
          label={t("marking.start")}
        />
        <InputComponent
          defaultValue={marking.playerState.offset2}
          placeholder={marking.playerState.offset2}
          disabled={true}
          required={isRequiredList.durationTime}
          onChange={() => {}}
          label={t("marking.end")}
        />
      </TimeContainer>

      <DropdownGlobal
        width="413px"
        labelName={t("marking.participant")}
        required
        options={attedants}
        defaultValue={
          loadingAttendant ? t("common.loading") : defaultAttedantName
        }
        showDefaultValue={
          (isInqueritoProduct && Boolean(defaultAttedantName)) ||
          (isEdit && Boolean(defaultAttedantName)) ||
          (!isBegining && Boolean(defaultAttedantName)) ||
          loadingAttendant
        }
        selected={attendantId}
        disabled={isInqueritoProduct || (isInquerito && Boolean(hearingFileId))}
        wantAnObject
        setSelected={handleSelectedAttendant}
      />

      {!isBegining || isEdit ? (
        <Multiline
          label={"Descrição"}
          name="markDescriptionName"
          onChange={setSubject}
          value={subject}
          required
          rows={19}
          error={descriptionHasError}
          helperText={
            descriptionHasError ? "Informe uma descrição para a marcação." : ""
          }
        />
      ) : null}
    </Container>
  );
};
